<template>
	<b-container>
		<b-card >
			<h4 class="card-title">{{this.$session.get('username')}}</h4>
          	<p class="card-category">{{this.$session.get('role')}}</p>
			<b-list-group>
			<b-list-group-item v-for="(value, key) in data" :key="key">{{ key }}: {{ value }}</b-list-group-item>
			</b-list-group>
		</b-card>
	</b-container>
</template>
<script>
import http from "../http-common";
export default {
	name:"Profile",
	data() {
      return{
        data:{}
      }},
	methods:{
		async getemployeedetails() {
		     await http
		     .post("/getemployeebyusername",this.$session.get('username'))
		     .then(response => {
			        this.data=response.data
		          })
		     .catch(e => {
		       console.log(e);
		     });
		   }
	},
	created() {
		this.getemployeedetails()
  	}
}
</script>